import { combineReducers } from "redux";
import FETCH_MASTER_DATA from "../../constants/masterDataConstant";

const planById = (state = {}, action) => {
    switch (action.type) {
        case FETCH_MASTER_DATA:
            return {
                ...state,
                ...action.payload.plans,
            };
        default:
            return state;
    }
};

// const planForInputs = (state = [], action) => {
//     switch (action.type) {
//         case FETCH_MASTER_DATA:
//             return Object.keys(action.payload.plans || {}).map(normalizeForOption("planName", "planId", action.payload.plans));
//         default:
//             return state;
//     }
// };

const allPlanIds = (state = [], action) => {
    switch (action.type) {
        case FETCH_MASTER_DATA:
            return Object.keys(action.payload.plans || {});
        default:
            return state;
    }
};


export default combineReducers({
    allIds: allPlanIds,
    byId: planById,
});